module.exports = __webpack_public_path__ + "assets/folder-shared-active.4bc58a8d.svg";